import { create } from 'zustand';

interface FeedbackState {
  /** Whether the feedback panel is open. It opens by itself at the 10 and 60 minute marks and from the You tab. */
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useFeedback = create<FeedbackState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
